function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-275-24H45v712h-320z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.324 19.186L.318 2.18A.96.96 0 0 1 .321.8.96.96 0 0 1 1.7.797l17.007 17.006c.39.39.39.989-.003 1.38a.96.96 0 0 1-1.38.003zM.318 17.803L17.324.797a.96.96 0 0 1 1.381.002.96.96 0 0 1 .003 1.381L1.702 19.186a.96.96 0 0 1-1.381-.002.96.96 0 0 1-.003-1.381z",
  fill: "#0D75DE",
  fillRule: "nonzero"
}));

function SvgCloseThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20"
  }, props), _ref);
}

export default SvgCloseThin;